/**
 * API Configuration for Agrotrack Dashboard
 * 
 * Central configuration for API endpoints, timeouts, and settings.
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  retries: 3,
  retryDelay: 1000, // 1 second
  
  endpoints: {
    // Health check
    health: '/health',
    
    // Prediction endpoints
    predict: '/predict',
    predictBatch: '/predict/batch',
    
    // Model management
    models: '/models',
    modelDetail: (modelName) => `/models/${modelName}`,
    modelMetrics: (modelName) => `/models/${modelName}/metrics`,
    modelComparison: '/models/comparison',
  },
  
  // Request headers
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

export const CHART_COLORS = {
  primary: '#4CAF50',
  secondary: '#2196F3',
  tertiary: '#FF9800',
  quaternary: '#9C27B0',
  success: '#4CAF50',
  warning: '#FF9800',
  error: '#f44336',
  info: '#2196F3',
  background: '#f5f5f5',
  text: '#333333',
};

export const PREDICTION_FEATURES = [
  { key: 'temp_avg', label: 'Average Temperature (°C)', type: 'number', min: -10, max: 50 },
  { key: 'precipitation', label: 'Precipitation (mm)', type: 'number', min: 0, max: 1000 },
  { key: 'gdd', label: 'Growing Degree Days', type: 'number', min: 0, max: 5000 },
  { key: 'crop_diversity_index', label: 'Crop Diversity Index', type: 'number', min: 1, max: 10 },
  { key: 'soil_health', label: 'Soil Health Score', type: 'number', min: 0, max: 100 },
  { key: 'water_availability', label: 'Water Availability Score', type: 'number', min: 0, max: 100 },
];

export const CROP_TYPES = [
  'Corn',
  'Soybeans',
  'Wheat',
  'Cotton',
  'Rice',
  'Barley',
  'Sorghum',
  'Oats',
];

export const STATES = [
  { code: 'VA', name: 'Virginia' },
  { code: 'MD', name: 'Maryland' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'WV', name: 'West Virginia' },
];

export default API_CONFIG;
